module.exports = __webpack_public_path__ + "img/btn_history.cafa757f.png";